// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceAndReviews_container__77lF0","ratings":"PriceAndReviews_ratings__sTo_t"};